import { httpPost } from '../../../modules/api/axios_api';
import Constants, { fixProtocol } from '../../../constants/constants';
import { ActivityData } from '../../components/ActivityAttribution/types';
import { Player } from '../Restorative/types';

import { AxiosResponse } from 'axios';

const BLUEPRINT_URL = `${fixProtocol(Constants.BACKEND_URL)}/activity-executions/`;

interface AttributionResponseData {
  new_activity_execution_id: number;
}
export const attributeActivityExecution = async (activityData: ActivityData, playerIds: Player[]) => {
  const participants = playerIds.map((player) => {
    return player.id;
  });
  const url = new URL(BLUEPRINT_URL + 'upsert-activity-execution');

  const params = {
    title: activityData.title,
    duration: activityData.duration,
    activity_type: activityData.activityType,
    participants: participants,
    restorative_program_id: activityData.program.id,
  };
  try {
    const response = await httpPost(url, params);
    const responseData = response as AxiosResponse<AttributionResponseData>;
    return responseData.data.new_activity_execution_id;
  } catch (e) {
    console.error(e);
    return false;
  }
};
